<template>
    <div class="how-get-coins-dialog">
        <div class="how-get-coins-dialog__header">
            <div class="how-get-coins-dialog__title">Как получить баллы РСВ?</div>
        </div>
        <main class="how-get-coins-dialog__main">
            <div class="how-get-coins-dialog__group">
                <header class="how-get-coins-dialog__group-header">
                    <span class="how-get-coins-dialog__group-header-number">1</span>
                    <h3 class="how-get-coins-dialog__group-header-title">
                        Участвуй в проектах Платформы и ее партнеров
                    </h3>
                </header>
                <!-- <div class="how-get-coins-dialog__group-icons">
                    <IconGoodNews class="how-get-coins-dialog__svg--good-news" />
                    <IconSportTrack class="how-get-coins-dialog__svg--sport-track" />
                </div> -->
                <div class="how-get-coins-dialog__group-text">
                    Баллы за активности в проектах конвертируются в баллы РСВ
                </div>
                <div class="how-get-coins-dialog__group-icons">
                    <IconMathSummCoins class="how-get-coins-dialog__svg--math-summ-coins" />
                </div>
            </div>

            <div class="how-get-coins-dialog__group how-get-coins-dialog__group--reverse-bg">
                <header class="how-get-coins-dialog__group-header">
                    <span class="how-get-coins-dialog__group-header-number">2</span>
                    <h3 class="how-get-coins-dialog__group-header-title">Меняй шаги на баллы</h3>
                </header>
                <ol class="how-get-coins-dialog__group-list">
                    <li class="how-get-coins-dialog__group-list-item">
                        <p>
                            <span style="font-weight: 600"
                                >Разреши приложению РСВ получать информацию о твоих шагах</span
                            >
                            из приложений, посвященных здоровью (Apple Health для IOS или Google fit для Android).
                        </p>
                        <div class="how-get-coins-dialog__group-icons" v-if="!isMobile">
                            <IconRuStore class="how-get-coins-dialog__svg--ru-store" />
                            <IconAppStore class="how-get-coins-dialog__svg--app-store" />
                        </div>
                    </li>
                    <li class="how-get-coins-dialog__group-list-item">
                        <p>
                            <span style="font-weight: 600">Ходи не меньше 10 000 шагов в день,</span>
                            и ты не только укрепишь здоровье, но и заработаешь баллы РСВ.
                        </p>
                    </li>
                    <li class="how-get-coins-dialog__group-list-item">
                        <p>
                            <span style="font-weight: 600">Не забудь проверить в рейтинге,</span>
                            кто наиболее активный в твоем регионе и стране.
                        </p>
                    </li>
                </ol>
            </div>

            <!-- Временно: маркет -->

            <!-- <div class="how-get-coins-dialog__already">Уже заработал?</div>

            <div class="how-get-coins-dialog__promo">Меняй накопления на бонусы в Маркете РСВ.</div>

            <a href="https://market.rsv.ru" class="how-get-coins-dialog__link-market" target="_blank">
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="how-get-coins-dialog__link-market-svg"
                >
                    <path
                        d="M15.0004 8V5C15.0004 2.79086 13.2095 1 11.0004 1C8.79123 1 7.00037 2.79086 7.00037 5V8M2.59237 9.35196L1.99237 15.752C1.82178 17.5717 1.73648 18.4815 2.03842 19.1843C2.30367 19.8016 2.76849 20.3121 3.35839 20.6338C4.0299 21 4.94374 21 6.77142 21H15.2293C17.057 21 17.9708 21 18.6423 20.6338C19.2322 20.3121 19.6971 19.8016 19.9623 19.1843C20.2643 18.4815 20.179 17.5717 20.0084 15.752L19.4084 9.35197C19.2643 7.81535 19.1923 7.04704 18.8467 6.46616C18.5424 5.95458 18.0927 5.54511 17.555 5.28984C16.9444 5 16.1727 5 14.6293 5L7.37142 5C5.82806 5 5.05638 5 4.44579 5.28984C3.90803 5.54511 3.45838 5.95458 3.15403 6.46616C2.80846 7.04704 2.73643 7.81534 2.59237 9.35196Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                В маркет
            </a>

            <div class="how-get-coins-dialog__group-best">
                <IconBox class="how-get-coins-dialog__svg--box" />
                <div>
                    А лучшие в рейтинге «Россия<br v-if="isMobile" />– страна возможностей» получат дополнительные призы
                    от Платформы!
                </div>
            </div> -->
        </main>
    </div>
</template>

<script>
import IconAppStore from './svg/IconAppStore.vue';
// import IconBox from './svg/IconBox.vue';
// import IconGoodNews from './svg/IconGoodNews.vue';
// import IconSportTrack from './svg/IconSportTrack.vue';
import IconMathSummCoins from './svg/IconMathSummCoins.vue';
import IconRuStore from './svg/IconRuStore.vue';

import { mapGetters } from 'vuex';

export default {
    name: 'HowGetCoinsDialog',
    components: {
        // IconBox,
        // IconGoodNews,
        // IconSportTrack,
        IconMathSummCoins,
        IconRuStore,
        IconAppStore,
    },
    computed: {
        ...mapGetters(['isMobile']),
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.how-get-coins-dialog {
    padding: mrem(30) mrem(16);
    padding-bottom: mrem(15);

    @include on-desktop {
        * {
            /* Стиль самого скроллбара */
            &::-webkit-scrollbar {
                width: rem(5); /* Ширина скроллбара */
            }
            /* Стиль трека (фона) скроллбара */
            &::-webkit-scrollbar-track {
                background: transparent; /* Цвет трека */
            }
            /* Стиль ползунка (то, что движется) */
            &::-webkit-scrollbar-thumb {
                background-color: #f0f0f6; /* Цвет ползунка */
                border-radius: rem(8); /* Скругление углов */
                border: none;
            }
            /* Стиль при наведении */
            &::-webkit-scrollbar-thumb:hover {
                background-color: #ccccd7; /* Цвет при наведении */
            }
        }
    }

    @include on-desktop {
        padding: 0;
        border-radius: rem(10);
    }

    * {
        font-family: 'Montserrat', sans-serif;
    }

    @include on-desktop {
        min-height: 0;
    }

    &__title {
        margin: 0;
        font-size: mrem(18);
        line-height: mrem(24);
        font-weight: 600;
        margin-bottom: mrem(24);
        color: #251f45;

        @include on-desktop {
            font-size: rem(26);
            line-height: rem(32);
            font-weight: 600;
            margin-bottom: rem(24);
        }
    }

    &__header {
        margin-bottom: mrem(24);

        @include on-desktop {
            margin-bottom: rem(24);
        }
    }

    &__group {
        margin-bottom: mrem(24);
        position: relative;
        z-index: 1;
        padding: mrem(10);
        border-radius: mrem(16);

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(325deg, rgba(54, 237, 200, 0.4) 0%, rgba(160, 54, 234, 0.4) 100%);
            z-index: -1;
            opacity: 0.2;
            border-radius: mrem(16);
        }

        &--reverse-bg {
            &::before {
                background: linear-gradient(325deg, rgba(160, 54, 234, 0.4) 0%, rgba(54, 237, 200, 0.4) 100%);
                opacity: 0.2;
            }
        }

        @include on-desktop {
            margin-bottom: rem(24);
            padding: rem(20);
            border-radius: rem(16);

            &::before {
                border-radius: rem(16);
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    &__group-header {
        display: flex;
        align-items: flex-start;
        margin-bottom: mrem(16);

        @include on-desktop {
            margin-bottom: rem(16);
        }
    }

    &__group-header-number {
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(14);
        color: white;
        margin-right: mrem(10);
        flex-shrink: 0;
        border-radius: 50%;
        width: mrem(30);
        height: mrem(30);
        background: #69609f;
        display: flex;
        justify-content: center;
        align-items: center;

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(14);
            margin-right: rem(10);
            width: rem(30);
            height: rem(30);
        }
    }

    &__group-header-title {
        margin: 0;
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(24);
        color: #2a2626;

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
        }
    }

    &__group-icons {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(10);

        @include on-desktop {
            gap: rem(10);
            justify-content: flex-start;
        }
    }

    &__group-text {
        margin-top: mrem(16);
        margin-bottom: mrem(16);
        font-size: mrem(16);
        line-height: mrem(20);

        @include on-desktop {
            margin-top: rem(16);
            margin-bottom: rem(16);
            font-size: rem(16);
            line-height: rem(20);
        }
    }

    &__group-icon {
        margin-right: mrem(10);

        @include on-desktop {
            margin-right: rem(10);
        }
    }

    &__group-icon:last-child {
        margin-right: 0;
    }

    &__group-list {
        margin: 0;
        padding-left: mrem(20);

        @include on-desktop {
            padding-left: rem(25);
            margin-top: rem(10);
        }
    }

    &__group-list-item {
        font-weight: 600;
        margin-bottom: mrem(24);
        font-size: mrem(16);
        line-height: mrem(22);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(22);
            margin-bottom: rem(24);
        }

        p {
            font-weight: 400;
            margin: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    &__already {
        font-size: mrem(18);
        line-height: mrem(24);
        font-weight: 500;
        margin: mrem(20) 0;

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
            margin: rem(20) 0;
        }
    }

    &__promo {
        font-size: mrem(18);
        line-height: mrem(24);
        font-weight: 600;

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
        }
    }

    &__group-best {
        display: flex;
        align-items: center;
        gap: mrem(20);
        margin-top: mrem(20);

        svg {
            flex-shrink: 0;
        }

        div {
            font-size: mrem(16);
            line-height: mrem(22);
            font-weight: 500;
        }

        @include on-desktop {
            gap: rem(20);
            margin-top: rem(20);

            div {
                font-size: rem(16);
                line-height: rem(22);
            }
        }
    }

    &__link-market {
        border-radius: mrem(10);
        padding: mrem(9) mrem(20);
        width: 100%;
        height: 42px;
        background: #69609f;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(10);
        color: white;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        margin-top: mrem(20);

        @include on-desktop {
            border-radius: rem(10);
            padding: rem(9) rem(20);
            height: rem(42);
            font-size: rem(14);
            line-height: rem(20);
            margin-top: rem(20);
            width: rem(160);
            gap: rem(10);

            svg {
                width: rem(22);
            }
        }
    }

    &__svg {
        &--good-news {
            width: mrem(152);

            @include on-desktop {
                width: rem(152);
            }
        }
        &--sport-track {
            width: mrem(137);

            @include on-desktop {
                width: rem(137);
            }
        }
        &--math-summ-coins {
            width: mrem(296);

            @include on-desktop {
                width: rem(296);
            }
        }
        &--box {
            width: mrem(65);

            @include on-desktop {
                width: rem(65);
            }
        }
        &--ru-store {
            width: mrem(129);

            @include on-desktop {
                width: rem(129);
                margin-top: rem(20);
            }
        }
        &--app-store {
            width: mrem(139);

            @include on-desktop {
                width: rem(139);
                margin-top: rem(20);
            }
        }
    }

    &__main {
        @include on-desktop {
            max-height: rem(640);
            overflow-y: auto;
            padding-right: rem(20);
        }
    }
}
</style>
